import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/imperium-shell.css";
import App from "./App";
import { installAudioUnlock } from "./utils/audioCore";
import { Capacitor } from "@capacitor/core";
import { installSafeAreaGuard } from "./utils/safeArea";

installAudioUnlock();
// Safe-area insets only apply inside the installed app; browsers/preview shells handle their own bars.
if (Capacitor.isNativePlatform()) document.documentElement.classList.add("bliss-native");
installSafeAreaGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
